export default class SampleList {
  constructor(json, excludedTopics) {
    this.samples = json.samples;
    this.topics = json.all_topics.filter(t => !excludedTopics.includes(t));

    this.samplesByMonth = new Map();

    for(let s of this.samples) {
      s.supplement_topics = s.supplement_topics.filter(t => this.topics.includes(t));
      this.samplesByMonth.set(`${s.year}::${s.month}`, s);
    }
  }

  getSample(year, month) {
    return this.samplesByMonth.get(`${year}::${month}`);
  }

  getTopics(year, month) {
    const sample = this.getSample(year, month);
    return sample ? sample.supplement_topics : [];
  }
}
